import { connect } from 'react-redux';
import {
  getInventoryExportPresignedUrl,
  getIsFetchingInventoryExportPresignedUrl
} from '../../../redux/Inventory/selectors/export';
import { fetchInventoryExportUrl } from '../../../redux/Inventory/sagas/routines';
import { setInventoryExportInProgress } from '../../../redux/Inventory/actions';
import ExportButton from '../../../components/inventory/ExportCsvButton';

function mapStateToProps(state, props) {
  return {
    ...props,
    exportUrl: getInventoryExportPresignedUrl(state),
    isFetching: getIsFetchingInventoryExportPresignedUrl(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onExport: (type, options) => {
      dispatch(setInventoryExportInProgress(type));
      dispatch(fetchInventoryExportUrl({ type, options }));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExportButton);
